import { ObjectSchema, bool, object, string } from 'yup';
import { MYS_MOBILE_PREFIX } from '../constants';
import { ErrorMessage } from '../enums';
import { ContactDetailFormValues } from '../types/form';

export const contactDetailSchema: ObjectSchema<ContactDetailFormValues> =
  object({
    name: string()
      .required(ErrorMessage.Required)
      .min(3, ErrorMessage.Name)
      .max(150, ErrorMessage.Name),
    mobilePrefix: string()
      .default(MYS_MOBILE_PREFIX)
      .required(ErrorMessage.Required),
    mobile: string()
      .required(ErrorMessage.Required)
      .min(3, ErrorMessage.Mobile)
      .max(18, ErrorMessage.Mobile),
    email: string().email().required(ErrorMessage.Required),
    agreeToTerms: bool()
      .oneOf([true], ErrorMessage.CheckRequired)
      .required(ErrorMessage.Required),
  });
